import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "../../../../api/agent";
import { AppResponse } from "../../../../models/app/AppResponse";

export const promotionApi = createApi({
  reducerPath: "promotionApi",
  baseQuery: axiosBaseQuery(),
  endpoints: (build) => ({
    getSyncedCategoriesAndMfrs: build.mutation<
      AppResponse<any>,
      { productType: number }
    >({
      query: ({ productType }) => ({
        url: `api/Promotions/Products/CategoriesManufacturers?productType=${productType}`,
      }),
    }),
    getSyncedProductNumbers: build.mutation<
      AppResponse<any>,
      {
        productLines: string[];
        manufacturers: string[];
        productType: number;
      }
    >({
      query: (data) => ({
        url: `api/Promotions/Products/ProductNumbers`,
        method: "post",
        data: data,
      }),
    }),
    createPromotion: build.mutation<
      AppResponse<string>,
      {
        name: string;
        startDate: any;
        endDate: any;
        productType: any;
        basePriceType: string;
        discountMethod: any;
        discountValue: any;
        category: string[];
        brand: string[];
        productNumber: string[];
      }
    >({
      query: (data) => ({
        url: `api/Promotions`,
        method: "post",
        data: data,
      }),
    }),
    getPromotions: build.mutation<AppResponse<any>, void>({
      query: () => ({
        url: `api/Promotions`,
      }),
    }),
    deletePromotion: build.mutation<
      AppResponse<string>,
      { promotionId: string }
    >({
      query: ({ promotionId }) => ({
        url: `api/Promotions/${promotionId}`,
        method: "delete",
      }),
    }),
    getPromotionProducts: build.mutation<
      AppResponse<any>,
      { promotionId: string }
    >({
      query: ({ promotionId }) => ({
        url: `api/Promotions/${promotionId}/Products`,
      }),
    }),
    applyPromotionById: build.mutation<
      AppResponse<string>,
      { aggregatePromotionalPriceId: string }
    >({
      query: ({ aggregatePromotionalPriceId }) => ({
        url: `api/Promotions/ApplyPromotionById?aggregatePromotionalId=${aggregatePromotionalPriceId}`,
        method: "post",
      }),
    }),
  }),
});

export const {
  useGetSyncedCategoriesAndMfrsMutation,
  useGetSyncedProductNumbersMutation,
  useCreatePromotionMutation,
  useGetPromotionsMutation,
  useDeletePromotionMutation,
  useGetPromotionProductsMutation,
  useApplyPromotionByIdMutation,
} = promotionApi;
